"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HmoRecordAppeal$ = exports.HmoRecordAppeal$outboundSchema = exports.HmoRecordAppeal$inboundSchema = void 0;
exports.hmoRecordAppealToJSON = hmoRecordAppealToJSON;
exports.hmoRecordAppealFromJSON = hmoRecordAppealFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.HmoRecordAppeal$inboundSchema = z.object({
    appeal_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    appeal_result: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "appeal_date": "appealDate",
        "appeal_result": "appealResult",
    });
});
/** @internal */
exports.HmoRecordAppeal$outboundSchema = z.object({
    appealDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    appealResult: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        appealDate: "appeal_date",
        appealResult: "appeal_result",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HmoRecordAppeal$;
(function (HmoRecordAppeal$) {
    /** @deprecated use `HmoRecordAppeal$inboundSchema` instead. */
    HmoRecordAppeal$.inboundSchema = exports.HmoRecordAppeal$inboundSchema;
    /** @deprecated use `HmoRecordAppeal$outboundSchema` instead. */
    HmoRecordAppeal$.outboundSchema = exports.HmoRecordAppeal$outboundSchema;
})(HmoRecordAppeal$ || (exports.HmoRecordAppeal$ = HmoRecordAppeal$ = {}));
function hmoRecordAppealToJSON(hmoRecordAppeal) {
    return JSON.stringify(exports.HmoRecordAppeal$outboundSchema.parse(hmoRecordAppeal));
}
function hmoRecordAppealFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HmoRecordAppeal$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HmoRecordAppeal' from JSON`);
}
//# sourceMappingURL=hmorecordappeal.js.map